module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "推广员计划"
    }
  }, [_c('el-alert', {
    staticClass: "alert-text",
    attrs: {
      "title": "商家可邀请员工、合作伙伴、朋友等作为推广员一起推广您的店铺或商品, 成功推广后给予推广员奖励，以此给店铺带来更多的曝光和销售提升",
      "type": "info",
      "close-text": " "
    }
  }), _vm._v(" "), _c('el-switch', {
    attrs: {
      "width": 50,
      "active-value": "true",
      "inactive-value": "false",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.isOpenPopularize),
      callback: function($$v) {
        _vm.$set(_vm.form, "isOpenPopularize", $$v)
      },
      expression: "form.isOpenPopularize"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推广商品"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.goods),
      callback: function($$v) {
        _vm.$set(_vm.form, "goods", $$v)
      },
      expression: "form.goods"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_c('p', [_vm._v("全部商品，表示所有的商品推广进行返佣。指定推广商品后，只有设置指定的商品可以进行推广返佣")]), _vm._v(" "), _c('p', [_vm._v("注意：将指定推广商品模式切换到全部商品模式，不会清空以前的选择，重新再切回指定商品模式，保留以前的选择商品")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "all"
    }
  }, [_vm._v("全部商品")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "select"
    }
  }, [_vm._v("指定推广商品")])], 1)], 1), _vm._v(" "), (_vm.form.isOpenPopularize == 'true') ? [_c('el-form-item', {
    attrs: {
      "label": "提现限制"
    }
  }, [_vm._v("\n            用户最少申请提现 "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "required": "",
      "min": "1",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.limit_rebate),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_rebate", $$v)
      },
      expression: "form.limit_rebate"
    }
  }), _vm._v("元\n        ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算限制"
    }
  }, [_vm._v("\n            订单完成 "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.limit_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_time", $$v)
      },
      expression: "form.limit_time"
    }
  }), _vm._v(" 天后结算\n        ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成为推广员门槛"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.change_promoter.type),
      callback: function($$v) {
        _vm.$set(_vm.form.change_promoter, "type", $$v)
      },
      expression: "form.change_promoter.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "no_threshold"
    }
  }, [_vm._v("无门槛成为推广员")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "internal"
    }
  }, [_vm._v("仅内部可推广")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "vip_grade"
    }
  }, [_vm._v("成为指定付费等级会员")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "consume_money"
    }
  }, [_vm._v("会员消费达到指定金额")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "order_num"
    }
  }, [_vm._v("会员已完成订单数")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.change_promoter.type == 'vip_grade'),
      expression: "form.change_promoter.type == 'vip_grade'"
    }],
    staticClass: "gap-text"
  }, [_vm._v("\n              选择付费等级\n              "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.change_promoter.filter.vip_grade),
      callback: function($$v) {
        _vm.$set(_vm.form.change_promoter.filter, "vip_grade", $$v)
      },
      expression: "form.change_promoter.filter.vip_grade"
    }
  }, _vm._l((_vm.vipGradeList), function(item) {
    return _c('el-option', {
      key: item.lv_type,
      attrs: {
        "label": item.grade_name,
        "value": item.lv_type
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.change_promoter.type == 'consume_money'),
      expression: "form.change_promoter.type == 'consume_money'"
    }],
    staticClass: "gap-text"
  }, [_vm._v("\n              达到 "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.change_promoter.filter.consume_money),
      callback: function($$v) {
        _vm.$set(_vm.form.change_promoter.filter, "consume_money", $$v)
      },
      expression: "form.change_promoter.filter.consume_money"
    }
  }), _vm._v(" 元\n            ")], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.change_promoter.type == 'order_num'),
      expression: "form.change_promoter.type == 'order_num'"
    }],
    staticClass: "gap-text"
  }, [_vm._v("\n              完成 "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.change_promoter.filter.order_num),
      callback: function($$v) {
        _vm.$set(_vm.form.change_promoter.filter, "order_num", $$v)
      },
      expression: "form.change_promoter.filter.order_num"
    }
  }), _vm._v(" 笔\n            ")], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返佣类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.commission_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "commission_type", $$v)
      },
      expression: "form.commission_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "money"
    }
  }, [_vm._v("金额")]), _vm._v(" "), (_vm.system_mode === 'platform') ? _c('el-radio', {
    attrs: {
      "label": "point"
    }
  }, [_vm._v("积分")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返佣计算类型"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("如果商品未指定，返佣计算类型，那么则使用当前设置的通用方式，如果在商品中指定了返佣模式，那么指定商品则使用自己的返佣方式")]), _vm._v(" "), _c('el-radio-group', {
    on: {
      "change": _vm.changePopularizeRatioType
    },
    model: {
      value: (_vm.form.popularize_ratio.type),
      callback: function($$v) {
        _vm.$set(_vm.form.popularize_ratio, "type", $$v)
      },
      expression: "form.popularize_ratio.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "profit"
    }
  }, [_vm._v("按利润分佣")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "order_money"
    }
  }, [_vm._v("按订单金额分佣")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推广员奖金设置"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.popularize_ratio.type == 'profit'),
      expression: "form.popularize_ratio.type == 'profit'"
    }]
  }, [_c('el-alert', {
    staticClass: "alert-text",
    attrs: {
      "title": "商品利润 ×  百分比，其中商品利润为【支付金额-运费-商品成本价】",
      "type": "info",
      "close-text": " "
    }
  }), _vm._v(" "), _vm._l((_vm.form.popularize_ratio.profit), function(item, key) {
    return _c('el-row', {
      key: key
    }, [_c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_vm._v("\n                        " + _vm._s(item.name) + "：\n                    ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "required": "",
        "min": "0",
        "maxlength": "3",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.popularize_ratio.profit[key].ratio),
        callback: function($$v) {
          _vm.$set(_vm.form.popularize_ratio.profit[key], "ratio", $$v)
        },
        expression: "form.popularize_ratio.profit[key].ratio"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("%")])], 2)], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.popularize_ratio.type == 'order_money'),
      expression: "form.popularize_ratio.type == 'order_money'"
    }]
  }, [_c('el-alert', {
    staticClass: "alert-text",
    attrs: {
      "title": "订单金额 × 百分比，其中订单金额为【支付金额-运费】",
      "type": "info",
      "close-text": " "
    }
  }), _vm._v(" "), _vm._l((_vm.form.popularize_ratio.order_money), function(item, key) {
    return _c('el-row', {
      key: key
    }, [_c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_vm._v("\n                        " + _vm._s(item.name) + "：\n                    ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "required": "",
        "min": "0",
        "maxlength": "3",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.popularize_ratio.order_money[key].ratio),
        callback: function($$v) {
          _vm.$set(_vm.form.popularize_ratio.order_money[key], "ratio", $$v)
        },
        expression: "form.popularize_ratio.order_money[key].ratio"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("%")])], 2)], 1)], 1)
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "虚拟店铺"
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 50,
      "active-value": "true",
      "inactive-value": "false",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.isOpenShop),
      callback: function($$v) {
        _vm.$set(_vm.form, "isOpenShop", $$v)
      },
      expression: "form.isOpenShop"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "充值返佣"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("充值返佣，只支持积分返佣")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "width": 50,
      "active-value": "true",
      "inactive-value": "false",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.isOpenRecharge),
      callback: function($$v) {
        _vm.$set(_vm.form, "isOpenRecharge", $$v)
      },
      expression: "form.isOpenRecharge"
    }
  })], 1), _vm._v(" "), (_vm.form.isOpenRecharge == 'true') ? _c('el-form-item', {
    attrs: {
      "label": "充值返佣设置"
    }
  }, [_c('div', _vm._l((_vm.form.recharge.profit), function(item, key) {
    return _c('el-row', {
      key: key
    }, [_c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_vm._v("\n                          " + _vm._s(item.name) + "：\n                      ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "required": "",
        "min": "0",
        "maxlength": "3",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.recharge.profit[key].ratio),
        callback: function($$v) {
          _vm.$set(_vm.form.recharge.profit[key], "ratio", $$v)
        },
        expression: "form.recharge.profit[key].ratio"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("%")])], 2)], 1)], 1)
  }), 1)]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4c5d9a0f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c5d9a0f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/popularize/setting.vue
// module id = 2693
// module chunks = 0